import { render, staticRenderFns } from "./connect.vue?vue&type=template&id=3cb8048e&scoped=true&"
import script from "./connect.vue?vue&type=script&lang=js&"
export * from "./connect.vue?vue&type=script&lang=js&"
import style0 from "./connect.vue?vue&type=style&index=0&id=3cb8048e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb8048e",
  null
  
)

export default component.exports